import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/share';

@Injectable()
export class SpinnerService {
    public status: Subject<boolean> = new Subject();
    private _activeRequests: number = 0;

    public get active(): boolean {
        return this._activeRequests > 0;
    }

    public start(): void {
        this._activeRequests++;
        if (this._activeRequests === 1) {
            this.status.next(true);
        }
    }

    public stop(): void {
        if (this._activeRequests > 0) {
            this._activeRequests--;
        }
        if (this._activeRequests === 0) {
            this.status.next(false);
        }
    }
}
